import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "label", "description", "count", "status", "isSelected", "isNew", "i18n", "isDisabled", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { StyledTab, StyledTabAssistive, StyledTabCount, StyledTabIcon, StyledTabLabel, StyledTabChip, StyledTabTitle } from './Tab.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Tab = forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      label = _ref.label,
      description = _ref.description,
      count = _ref.count,
      status = _ref.status,
      isSelected = _ref.isSelected,
      isNew = _ref.isNew,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? {
    "new": 'New'
  } : _ref$i18n,
      isDisabled = _ref.isDisabled,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 2 : _ref$id,
      rest = _objectWithoutProperties(_ref, _excluded);

  var statusProps = {
    variant: 'status',
    status: 'neutral'
  };
  return _jsxs(StyledTab, _objectSpread(_objectSpread({
    ref: ref,
    role: "tab",
    id: "tab:".concat(id),
    tabIndex: isSelected ? 0 : -1,
    disabled: isDisabled,
    "aria-label": label,
    "aria-selected": isSelected,
    "aria-disabled": isDisabled,
    "aria-controls": "panel:".concat(id)
  }, rest), {}, {
    children: [_jsxs(StyledTabTitle, {
      children: [icon && _jsx(StyledTabIcon, {
        icon: icon,
        size: 14
      }), _jsx(StyledTabLabel, {
        isSelected: isSelected,
        children: label
      }), count && _jsxs(StyledTabCount, {
        children: ["(", count, ")"]
      }), isNew && _jsx(StyledTabChip, _objectSpread(_objectSpread({
        size: "small"
      }, statusProps), {}, {
        children: i18n["new"]
      }))]
    }), description && _jsx(StyledTabAssistive, {
      children: description
    })]
  }));
});
export default Tab;